<sim-assessable-group-panel [type]="AssessablePanelType.Assessment" [scoreTemplate]="groupScoreTemplate">
	<ng-template #groupScoreTemplate let-data>
		@if (AssessmentAnswerPanelVariant.ExaminerView && SimConfigurationService.settings.showScoringForExaminer) {
			<ng-container *ngTemplateOutlet="groupScoreTemplateImpl; context: {$implicit: data}" />
		} @else if (store.mode() !== AssessablePanelMode.Answer) {
			<ng-container *ngTemplateOutlet="groupScoreTemplateImpl; context: {$implicit: data}" />
		}
	</ng-template>

	<ng-template #groupScoreTemplateImpl let-data>
		<mat-divider [vertical]="true" />

		<div class="scoreInHeader">
			<div class="reachedScore">
				{{ getGroupScore(data.groupId) }}
			</div>
			/
			<div class="maxScore">
				{{ getMaxGroupScore(data.groupId) }}
			</div>
		</div>

		<mat-divider [vertical]="true" />
	</ng-template>

	<ng-template assessableItemTemplate let-data [assessable]="assessable()">
		@switch (variant()) {
			@case (AssessmentAnswerPanelVariant.RecordingView) {
				<sim-assessment-item
					[data]="data"
					[compactLayout]="false"
					[hideExpansionArea]="false"
					[hideScore]="false"
					[isInArchive]="isInArchive()"
					(onTimestampClicked)="onJumpToItem.emit(data.item.answerTime)"
				/>
			}
			@case (AssessmentAnswerPanelVariant.ConductedView) {
				<sim-assessment-item
					[data]="data"
					[compactLayout]="true"
					[hideExpansionArea]="false"
					[hideScore]="false"
					[isInArchive]="false"
					(onTimestampClicked)="onJumpToItem.emit(data.item.answerTime)"
				/>
			}
			@case (AssessmentAnswerPanelVariant.ExaminerView) {
				<sim-assessment-item
					[data]="data"
					[compactLayout]="true"
					[hideExpansionArea]="!SimConfigurationService.settings.showCompetenceCategoriesForExaminer"
					[hideScore]="!SimConfigurationService.settings.showScoringForExaminer"
					[isInArchive]="false"
					(onTimestampClicked)="onJumpToItem.emit(data.item.answerTime)"
				/>
			}
			@case (AssessmentAnswerPanelVariant.PeerPracticeView) {
				<sim-assessment-item
					[data]="data"
					[compactLayout]="true"
					[hideExpansionArea]="!SimConfigurationService.settings.showCompetenceCategoriesForExaminer"
					[hideScore]="!SimConfigurationService.settings.showScoringForExaminer"
					[isInArchive]="false"
					[isHintsDialogEnabled]="true"
					(onTimestampClicked)="onJumpToItem.emit(data.item.answerTime)"
				/>
			}
		}
	</ng-template>
</sim-assessable-group-panel>
